<template>
	<div class="tpl add-gift-wrap">
		<mt-header title="补充礼物" fixed>
		  <router-link :to="{name:'appointment-mine',query:{id:aid}}" slot="left">
		    <mt-button icon="back"></mt-button>
		  </router-link>
		</mt-header>
		<div class="gift-list">
			<ul>
				<li v-for="(item,index) in giftList">
					<div class="show-item">
						<img :src="item.girft_img_url" alt="" />
						<p class="item-option-num">
							<button class="item-del" @click="delNum(index,item.chooseNum)"><img src="../../assets/img/finds/find_sg_ic_sub.png"/></button>
							<span>{{item.chooseNum}}</span>
							<button class="item-add" @click="addNum(index,item.chooseNum)">+</button>
						</p>
						<span class="item-name">{{item.girft_name}}</span>
					</div>
					<p class="item-price">{{item.price}}桃花币</p>
				</li>
			</ul>
		</div>
		<div class="submit-btn">
			<button @click="submitNum">确定</button>
		</div>
	</div>
</template>

<script>
	export default{
		name:"add-gift",
		data(){
			return{
				uid:"",
				aid:"",	//当前约会id
				giftList:"",
			}
		},
		created(){
			this.uid = this.$store.state.UserId;	//获取当前用户的id
			this.$store.commit("changeTabChoosed","finds");		//属于finds模块
			this.$store.commit("changeTabBarShow",false);	//不显示navbar
			
			this.aid = this.$route.query.id;
			
			this.getInfo();
		},
		methods:{
			getInfo(){
				this.$axios({
					url:"gift/giftList",
					method:"post",
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.giftList = res.data.data.map(item=>{
							item.chooseNum = 0;
							return item;
						});
						console.log(this.giftList)
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			addNum(index,num){
				console.log(index,num);
				this.giftList[index].chooseNum++;
			},
			delNum(index,num){
				console.log(index,num);
				if(this.giftList[index].chooseNum>1){
					this.giftList[index].chooseNum--;
				}else{
					this.giftList[index].chooseNum = 0
				}
			},
			submitNum(){
//				console.log(this.giftList);
				let giftHasChoosed = [];
				this.giftList.map(function(item,index){
					let obj={};
					if(item.chooseNum>0){
						obj={
							gid:item.g_id,
							gnum:item.chooseNum,
							gimg:item.girft_img_url,
							gname:item.girft_name,
							gprice:item.price
						}
						giftHasChoosed.push(obj)
					}
					return obj;
				})
				console.log(giftHasChoosed);
				this.$router.push({
					name:"add-gift-cul",
					query:{
						id:this.aid,
					},
					params:{
						gift:giftHasChoosed
					}
				})
			}
		}
	}
</script>

<style scoped>
	.add-gift-wrap{
		padding-top: 2.5rem;
		padding-bottom: 4rem;
	}
	.gift-list ul{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
		padding: 0.3rem 0.5rem;
	}
	.gift-list li{
		width: 33%;
		text-align: center;
		padding: 0.3rem;
	}
	.gift-list li .show-item{
		background: #fff;
		box-shadow:0px 5px 10px 0px rgba(40,40,56,0.08);
		border-radius: 4px;
		position: relative;
		overflow: hidden;
	}
	.gift-list li .item-name{
		position: absolute;
		left: 0;
		top: 0;
		background: rgba(255,97,97,.6);
		font-size: 0.7rem;
		color: #fff;
		padding: 0.1rem 0.5rem;
		border-radius: 3px 0 3px 0;
	}
	.gift-list li img{
		width: 3.2rem;
		margin: 2rem 0 0.5rem;
	}
	.gift-list li .item-option-num{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 0.5rem 0.5rem;
	}
	.gift-list li .item-option-num button{
		width: 1.5rem;
		height: 1.5rem;
		border-radius: 50%;
		outline: 0;
		font-size: 1.2rem;
		font-weight: bold;
		border: 0;
		padding: 0;
		background: none;
	}
	.gift-list li .item-option-num .item-add{
		background: #FF6161;
		color: #fff;
	}
	.gift-list li .item-option-num .item-del{
		width: ;
	}
	.gift-list li .item-option-num .item-del img{
		width: 100%;
		margin: 0;
	}
	.gift-list li .item-price{
		font-size: 0.8rem;
		color: #7B7B7B;
		line-height: 1.6rem;
		text-align: left;
	}
	.submit-btn{
		position: fixed;
		width: 100%;
		padding: 0.5rem 1rem;
		background: #fff;
		bottom: 0;
		left: 0;
	}
	.submit-btn button{
		width: 100%;
		height: 2.8rem;
		font-size: 1rem;
		color: #fff;
		background:linear-gradient(90deg,rgba(135,91,251,1) 0%,rgba(203,184,253,1) 100%);
		border: 0;
		border-radius: 3px;
		outline: 0;
	}
</style>


// WEBPACK FOOTER //
// src/components/Finds/AppointAddGift.vue